import React from 'react';
import { X } from 'lucide-react';
import { inr } from './briefApi';

const fmt = (n) => (n == null ? '—' : n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : n);
const TH = 'px-2 py-1.5 text-left text-[10px] font-semibold uppercase tracking-wider text-[#6B6B6B] dark:text-zinc-400 whitespace-nowrap';
const TD = 'px-2 py-1.5 text-xs text-[#0F0F0F] dark:text-white';

export const ExclusivityBadge = ({ label }) => {
  const excl = /exclusive/i.test(label || '') && !/non/i.test(label || '');
  return <span className={`inline-block rounded-full px-2 py-0.5 text-[10px] font-semibold ${excl ? 'bg-[#FF451A]/10 text-[#FF451A]' : 'bg-black/[0.05] dark:bg-white/10 text-[#6B6B6B] dark:text-zinc-400'}`}>{label || 'Remaining'}</span>;
};

export const clientPrice = (v, m) => (v > 0 ? Math.round((v * (m > 0 ? m : 1)) / 100) * 100 : null);
const costHeaders = (cols) => cols.flatMap((c) => [`Creator ${c.label}`, `Client ${c.label.replace(/ Cost$/, '')} Price`]);

export const BriefCreatorList = ({ title, rows, costCols, markup, onRemove, showAddedBy, testid, empty }) => (
  <section data-testid={testid}>
    <div className="text-xs font-semibold uppercase tracking-[0.08em] text-[#0F0F0F] dark:text-white mb-2">{title} <span className="font-mono text-[#FF451A]">{rows.length}</span></div>
    {rows.length === 0 ? <p className="text-xs text-[#6B6B6B] dark:text-zinc-400 border border-dashed border-black/[0.12] dark:border-white/10 rounded-lg px-3 py-4">{empty}</p> : (
      <div className="overflow-x-auto border border-black/[0.08] dark:border-white/5 rounded-lg">
        <table className="w-full">
          <thead><tr>{['Creator', 'Exclusivity', 'Followers', 'Tier', 'City', ...costHeaders(costCols), ...(showAddedBy ? ['Added by'] : []), ''].map((h) => <th key={h} className={TH}>{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.creator_id} className="border-t border-black/[0.06] dark:border-white/5" data-testid={`${testid}-row-${c.creator_id}`}>
                <td className={TD}><div className="font-semibold">{c.name}</div>{c.instagram_handle && <a href={c.instagram_link} target="_blank" rel="noopener noreferrer" className="text-[10px] text-[#FF451A] hover:underline">@{c.instagram_handle}</a>}</td>
                <td className={TD}><ExclusivityBadge label={c.priority_label} /></td>
                <td className={`${TD} font-mono`}>{fmt(c.instagram_followers)}</td>
                <td className={TD}>{c.quality_tier || '—'}</td>
                <td className={TD}>{c.city || '—'}</td>
                {costCols.map((col) => (
                  <React.Fragment key={col.key}>
                    <td className={`${TD} font-mono`} data-testid={`${testid}-cost-${col.key}-${c.creator_id}`}>{inr(c[col.key])}</td>
                    <td className={`${TD} font-mono font-semibold text-[#0F9D58]`} data-testid={`${testid}-client-${col.key}-${c.creator_id}`}>{inr(clientPrice(c[col.key], markup))}</td>
                  </React.Fragment>
                ))}
                {showAddedBy && <td className={TD} data-testid={`${testid}-addedby-${c.creator_id}`}>{c.added_by_name || '—'}</td>}
                <td className={TD}>
                  <button onClick={() => onRemove(c)} title="Remove from brief" className="rounded-full p-1 text-[#6B6B6B] hover:text-red-500 hover:bg-red-500/10 transition-colors" data-testid={`${testid}-remove-${c.creator_id}`}><X size={12} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);
